module.exports = __webpack_public_path__ + "img/t3_s.f9a80789.jpg";